export enum Net2BeepleMethodsEnum {
    calculateNet4Concepts = 'calculateNet4Concepts',
    changeUserStatus = 'changeUserStatus',
    changeWorkplaceGuide = 'changeWorkplaceGuide',
    regularizeHourBag = 'regularizeHourBag',
    deleteCalendar = 'deleteCalendar',
    deleteDType = 'deleteDType',
    deleteDTypeData = 'deleteDTypeData',
    deleteNet4ConceptMapping = 'deleteNet4ConceptMapping',
    downloadFile = 'formdata?labor=downloadFile',
    downloadMasterXSSF = 'downloadMasterXSSF',
    downloadMasterFormStructureXSSF = 'downloadMasterFormStructureXSSF',
    downloadNet4WorkSummaryXSSF = 'downloadNet4WorkSummaryXSSF',
    downloadTrabajadorNet4WorkSummaryXSSF = 'downloadTrabajadorNet4WorkSummaryXSSF',
    downloadWorkplaceWorkSummaryXSSF = 'downloadWorkplaceWorkSummaryXSSF',
    downloadContractWorkSummaryXSSF = 'downloadContractWorkSummaryXSSF',
    exchangeToken = 'exchangeToken',
    flushCalendar = 'flushCalendar',
    flushCompany = 'flushCompany',
    flushCompanyUser = 'flushCompanyUser',
    flushDailyWorkplaceWorkConceptSummary = 'flushDailyWorkplaceWorkConceptSummary',
    flushDTypeDataItem = 'flushDTypeDataItem',
    flushDTypeExcelUpload = 'flushDTypeExcelUpload',
    flushDTypeRepositoryToGoLiveSchedule = "flushDTypeRepositoryToGoLiveSchedule",
    flushLocationChangeResult = 'flushLocationChangeResult',
    flushMasterCategoryTree = 'flushMasterCategoryTree',
    flushMasterOrder = 'flushMasterOrder',
    flushMonthlyContractWorkConceptSummary = 'flushMonthlyContractWorkConceptSummary',
    flushMonthlyWorkplaceWorkConceptSummary = 'flushMonthlyWorkplaceWorkConceptSummary',
    flushNet4ConceptMapping = 'flushNet4ConceptMapping',
    flushUserNodePrivileges = 'flushUserNodePrivileges',
    flushNet4WorkerGroup = 'flushNet4WorkerGroup',
    hackContractMinutes = 'hackContractMinutes',
    hackContractMinutesV2 = 'hackContractMinutesV2',
    nextValue = 'nextValue',
    notifySystemChangesForUsers = 'notifySystemChangesForUsers',
    preauthorize = 'preauthorize',
    refreshToken = 'refreshToken',
    removeDropzoneFile = 'removeDropzoneFile',
    retrieveAddressByGoogle = 'retrieveAddressByGoogle',
    retrieveCalendarDateList = 'retrieveCalendarDateList',
    retrieveCalendarWithDN = 'retrieveCalendarWithDN',
    retrieveCompanyUserList = 'retrieveCompanyUserList',
    retrieveDailyWorkplaceWorkConceptSummary = 'retrieveDailyWorkplaceWorkConceptSummary',
    retrieveDailyWorkplaceWorkConceptSummaryAggregate = 'retrieveDailyWorkplaceWorkConceptSummaryAggregate',
    retrieveContractWorkSummary = 'retrieveContractWorkSummary',
    retrieveDTypeBuilderCollection = 'retrieveDTypeBuilderCollection',
    retrieveDTypeByUri = 'retrieveDTypeByUri',
    retrieveDTypeDataCollection = 'retrieveDTypeDataCollection',
    retrieveDTypeDataItem = 'retrieveDTypeDataItem',
    retrieveDTypeRepositoryByUri = 'retrieveDTypeRepositoryByUri',
    retrieveEnumerationType = 'retrieveEnumerationType',
    retrieveErrorWorkConceptSummary = 'retrieveErrorWorkConceptSummary',
    retrieveLocationChangeRequest = 'retrieveLocationChangeRequest',
    retrieveMasterCategoryTree = 'retrieveMasterCategoryTree',
    retrieveMasterCollectionDN = 'retrieveMasterCollectionDN',
    retrieveMasterDataAsSelectOption = 'retrieveMasterDataAsSelectOption',
    retrieveMonthlyContractWorkConceptSummary = 'retrieveMonthlyContractWorkConceptSummary',
    retrieveNet2BeepleOu = 'retrieveNet2BeepleOu',
    retrieveNet4ConceptMapping = 'retrieveNet4ConceptMapping',
    retrieveNet4WorkerAssignments = 'retrieveNet4WorkerAssignments',
    retrieveNet4WorkerGroup = 'retrieveNet4WorkerGroup',
    retrieveNet4WorkSummary = 'retrieveNet4WorkSummary',
    retrieveProductividadPresencia = 'retrieveProductividadPresencia',
    retrieveTrabajadorNet4WorkSummary = 'retrieveTrabajadorNet4WorkSummary',
    retrieveMonthlyWorkplaceWorkConceptSummary = 'retrieveMonthlyWorkplaceWorkConceptSummary',
    retrieveWorkplaceWorkSummary = 'retrieveWorkplaceWorkSummary',
    searchBusPartaker = 'searchBusPartaker',
    searchCompanyUserList = 'searchCompanyUserList',
    searchDTypeDataCollection = 'searchDTypeDataCollection',
    searchNet4PresenceConcept = 'searchNet4PresenceConcept',
    searchDBNet4Worker = 'searchDBNet4Worker',
    signIn = 'signIn',
    synchronizeBeepleClient = 'synchronizeBeepleClient',
    synchronizeBeepleWorkplace = 'synchronizeBeepleWorkplace',
    synchronizeBeepleWorkplaceWeek = 'synchronizeBeepleWorkplaceWeek',
    synchronizeNextServicio_n2b = 'synchronizeNextServicio_n2b',
    toggleDTypeRepositoryHidden = 'toggleDTypeRepositoryHidden',
    toggleDTypeRepositoryLock = 'toggleDTypeRepositoryLock',
    toggleHourBag = 'toggleHourBag',
    updateMiniBus = 'updateMiniBus',
    updateNet2BeepleOu = 'updateNet2BeepleOu',
    uploadFile = 'uploadFile',
    uploadMasterXSSF = 'uploadMasterXSSF',
    validateMonthlyContractWorkConceptSummary = 'validateMonthlyContractWorkConceptSummary',
    validateDailyWorkplaceWorkConceptSummary = 'validateDailyWorkplaceWorkConceptSummary',
    validateWorkplaceWorkConceptSummary = 'validateWorkplaceWorkConceptSummary',
    validateMonthlyWorkplaceWorkConceptSummary = 'validateMonthlyWorkplaceWorkConceptSummary'
}
